function DropDownMenu({ children }) {
  return (
    <div className="dropdown sticky-top zindex-sticky" style={{ zIndex: 20 }}>
      <ul
        className="dropdown-menu"
        id="dropDownMenuList"
        aria-labelledby="dropDownMenu"
        style={{
          width: '100vw',
          maxWidth: '642px',
          // margin: ' auto' /* 使容器水平居中 */,
          // border: '1px solid #8D8C8C',
          borderRadius: '0px',
          // boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.25)',
          padding: '0px',
        }}
      >
        {children}
      </ul>
    </div>
  );
}

export default DropDownMenu;
